
export type TReviewSnippetsPicker = {
    selNHID: number
};

export type TReviewSnippetSelectionPaneProps = {
    cards: TSnippetItem[]
    reviewShowcaseData: TReviewShowcaseResponseItem[]
    selNHID: number
    setCards: React.Dispatch<React.SetStateAction<TSnippetItem[]>> 
};

export interface TReviewSnippetSelectionCardProps {
    id: any
    index: number
    reviewContext?: TItemReviewContext
    text: string
    moveCard: (dragIndex: number, hoverIndex: number) => void
    setCard: (cardItem: TSnippetItem) => void
}

export type TItemReviewContext = {
    sourceReviewID: number
    sourceReviewerDisplayName: string
    sourceReviewConnectionName: string
};

export type TItemErrorContext = {
    hasError: boolean
    errorMsg: string
};

export type TSnippetItem = {
    snippetID: number
    snippetText: string
    reviewContext?: TItemReviewContext
    errorContext?: TItemErrorContext
};

export type TDragItem = TSnippetItem & {
    index: number
    id: string
    type: string
};

export const DragItemTypes = {
    SnippetSource: 'snippet-source',
};

export type TReviewShowcaseResponseItem = {
    ReviewID: number
    Snippet: string
    Sequence: number
    ReviewerConnectionName: string | null
    ReviewerDisplayName: string
};

export type TReviewInfo = {
    ReviewID: number
    NHID: number
    OrgNHID: number
    ReviewerDisplayName: string
    ReviewContent: string
    OverallRating: number
    LastPublishedDate: string
    FirstPublishedDate: string
    PendingPublicationDate: string | null
    PublicationAuxiliaryExternalDescription: string
    Name: string
    Address1: string
    Address2: string | null
    City: string
    Zip: string
    StateCode: string
    ReviewRating: {
        RatingName: string
        RatingValueName: string
        RatingValue: number
    }[]
    PropertyCategoryName: string
    ExperienceTypeName: string
    ConnectionName: string
    Reply: string | null
    CreatedAt: string
};

export type TPublishedReviewsRowProps = {
    addCard: (cardItem: TSnippetItem) => void
    cards: TSnippetItem[]
    reviewInfo: TReviewInfo
};

export type TReviewSnippetsPreviewModalProps = {
    cards: TSnippetItem[]
    selNHID: number 
    totalReviews: number
};
